import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();

    oneCheckoutBtnRenderer.hide1CTarget({
      target: 'cart_button',
      selector: '.cart-drawer__summary #checkout',
      observeUrl: '/cart/add',
      observeForBtn: {
        container: 'body',
        nodeName: 'FORM'
      },
      dynamicBtn: `
        <button id="buyNow1CheckoutBtn" type="button" class="btn-1checkout btn-1checkout-style" onclick="closeCartDrawerViaTheme();oneCheckout.trigger1Checkout(this)">
          <span class="btn-1checkout-title">Check out</span>
          <span class="btn-1checkout-spinner dc-none"></span>
        </button>`
    });

    oneCheckoutBtnRenderer.render1CBtn({
      target: 'cart_button',
      selector: '.cart-drawer__summary #checkout',
      observeUrl: '/cart/add',
      observeForBtn: {
        container: 'body',
        nodeName: 'FORM'
      },
      dynamicBtn: `
        <button id="buyNow1CheckoutBtn" type="button" class="btn-1checkout btn-1checkout-style" onclick="closeCartDrawerViaTheme();oneCheckout.trigger1Checkout(this)">
          <span class="btn-1checkout-title">Check out</span>
          <span class="btn-1checkout-spinner dc-none"></span>
        </button>`
    });
    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
